import $ from 'jquery';
import { AJAX_URL } from './config';

// Catch when Additonal Info form is submitted
$('#register-additional-form').on('submit', function (e) {
  // Prevent default
  e.preventDefault();
  let best_describes_you = [];
  $.each($('input[name="best_describes_you"]:checked'), function () {
    best_describes_you.push($(this).val());
  });

  // Get form data
  const data = {
    best_describes_you: best_describes_you,
    redirect_to: $('#redirect_to').val()
  };

  $.ajax({
    url: `${AJAX_URL}wl_post_register_additional_form`,
    data: data,
    type: 'POST',
    dataType: 'json',
    encode: true,
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
  })
    .then(({ success, data }) => {
      if (!success) {
        $.each(data.errors, function (key, value) {
          $('#' + key)
            .parent()
            .append(
              '<small class="form__help u--color-red">' + value + '</small>'
            );
        });
        $('#notice').html(data.notice);
        return;
      } else {
        // Redirect to the page
        window.location.href = data.redirect;
      }
    })
    .catch((err) => console.log(err.message));
});

// Roles that prompt for state, ISD and school
let schoolRoles = $('#register-form').data('school-roles');
schoolRoles = schoolRoles ? String(schoolRoles).split(',') : [];

// Currently checked "describes you" values
function getDescribesYou() {
  const describes_you = [];
  $.each(
    $('#register-form input[name="describes_you[]"]:checked'),
    function () {
      describes_you.push($(this).val());
    }
  );
  return describes_you;
}

// Show/hide the state and school fields based on the selected roles and state
function toggleSchoolFields() {
  const describes_you = getDescribesYou();
  const hasSchoolRole = schoolRoles.some((role) =>
    describes_you.includes(role)
  );
  const isTexas = $('#register-form select[name="state"]').val() === 'Texas';

  $('#register-form .state_container').toggleClass(
    'u--display-none',
    !hasSchoolRole
  );
  $('#register-form .school_district_container').toggleClass(
    'u--display-none',
    !hasSchoolRole || !isTexas
  );
  $('#register-form .school_container').toggleClass(
    'u--display-none',
    !hasSchoolRole || !isTexas
  );
  $('#register-form .non_school_container').toggleClass(
    'u--display-none',
    !hasSchoolRole || isTexas
  );

  // Hidden fields still submit, so clear them once the school roles are
  // deselected. Otherwise a stale state would override the zip lookup.
  if (!hasSchoolRole) {
    $('#register-form select[name="state"]').val('');
    $('#register-form select[name="isd"]').val('');
    $('#register-form select[name="school"]').val('');
    $('#register-form input[name="non_texas_school"]').val('');
  }
}

// Catch when register form is submitted
$('#register-form').on('submit', function (e) {
  // Prevent default
  e.preventDefault();

  $('.login__submit').hide();
  $('.submit__loading').show();

  // Get form data
  const describes_you = getDescribesYou();

  const data = {
    first_name: $('#first_name').val(),
    last_name: $('#last_name').val(),
    email: $('#email').val(),
    password: $('#user_pass').val(),
    confirm_password: $('#user_pass_confirm').val(),
    website: $('#website').val(),
    describes_you: describes_you,
    recaptchaResponse: $('#recaptchaResponse').val(),
    opt_out: $('#opt_out').val(),
    redirect_to: $('#redirect_to').val(),
    zip: $('#zip').val(),
    phone: $('#phone').val(),
    state: $('#register-form select[name="state"]').val(),
    isd: $('#register-form select[name="isd"]').val(),
    school: $('#register-form select[name="school"]').val(),
    non_texas_school: $('#register-form input[name="non_texas_school"]').val(),
    hubspotutk: $('#hubspotutk').val()
  };

  $.ajax({
    url: `${AJAX_URL}wl_post_register_form`,
    data: data,
    type: 'POST',
    dataType: 'json',
    encode: true,
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
  })
    .then(({ success, data }) => {
      $('.login__submit').show();
      $('.submit__loading').hide();

      if (!success) {
        $.each(data.errors, function (key, value) {
          $('#' + key)
            .parent()
            .append(
              '<small class="form__help u--color-red">' + value + '</small>'
            );
        });
        $('#notice').html(data.notice);
        return;
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'registration',
          event_type: 'email_registration'
        });
        // Redirect to the page the user was on
        window.location.href = data.redirect;
      }
    })
    .catch((err) => console.log(err.message));
});

// After page load, check if form exists
$(document).ready(function () {
  // If it does, add the recaptcha
  if ($('#register-form').length) {
    // Attempt to read the HubSpot tracking cookie
    const hubspotCookie = document.cookie
      .split('; ')
      .find((row) => row.startsWith('hubspotutk='))
      ?.split('=')[1];

    // If found, attach it as a hidden input field
    if (hubspotCookie) {
      const form = document.getElementById('register-form');
      const hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'hubspotutk';
      hidden.id = 'hubspotutk';
      hidden.value = hubspotCookie;
      form.appendChild(hidden);
    }
  }
});

if ($('#register-form').length) {
  // Reveal the state/school fields when an Educator or Student role is checked
  $(document).on(
    'change',
    '#register-form input[name="describes_you[]"]',
    toggleSchoolFields
  );

  // Texas shows the ISD/School dropdowns, anywhere else shows free-text school
  $(document).on(
    'change',
    '#register-form select[name="state"]',
    toggleSchoolFields
  );

  // Repopulate the school dropdown whenever the ISD changes
  $(document).on('change', '#register-form select[name="isd"]', function () {
    const $school = $('#register-form select[name="school"]');

    $.ajax({
      url: `${AJAX_URL}wl_get_schools_by_district`,
      data: { isd: this.value },
      type: 'POST',
      dataType: 'json',
      encode: true,
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
    })
      .then(({ success, data }) => {
        if (!success) {
          console.error('Failed to fetch schools:', data.message);
          return;
        }

        $school.empty();
        $school.append('<option value="">Select a School</option>');
        $.each(data.schools, function (index, school) {
          $school.append(
            `<option value="${school.school_name}">${school.school_name}</option>`
          );
        });
      })
      .catch((err) => console.log(err.message));
  });

  // Sync visibility on load so validation errors come back with fields showing
  $(document).ready(toggleSchoolFields);
}

if ($('select[name="grade_level"]').length) {
  $('select[name="grade_level"]').on('change', function () {
    if (this.value === 'Other') {
      $('.grade_level_other_container').removeClass('u--display-none');
    } else {
      $('.grade_level_other_container').addClass('u--display-none');
    }
  });
}
